module.exports = __webpack_public_path__ + "img/ic_pk.b39995cf.png";